import React from 'react'

import { PianoSubscriptions } from 'modules/unsubscribe/components/Subscriptions'

import { AppName } from 'root-constants'

type TSubscriptionsTabProps = {
  onRequestWithdrawal: (subscriptionId: string, contract: string) => void
}

export const APP_SUBSCRIPTIONS_TABS: Partial<
  Record<AppName, React.FC<TSubscriptionsTabProps>>
> = {
  [AppName.HELLO_PIANO]: PianoSubscriptions,
}
